const a11yMonitor = require('../monitors/a11y');
const deviceInformationMonitor = require('../monitors/device-info');
const connectionInformationMonitor = require('../monitors/connection-info');
const browserInformationMonitor = require('../monitors/browser-info');
const windowInformationMonitor = require('../monitors/window-info');
const mlSessionInformationMonitor = require('../monitors/mlsession-info');
const { prepareConfiguration } = require('../config');
const { supportsFetchApi } = require('../support');

const start = args => {
  const settings = prepareConfiguration(args);
  if (!settings) {
    return;
  }

  try {
    if (supportsFetchApi()) {
      deviceInformationMonitor();
      connectionInformationMonitor();
      windowInformationMonitor();
      a11yMonitor(settings);
      browserInformationMonitor();
      mlSessionInformationMonitor();
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

module.exports = {
  start,
};
